<template>
  <main class="main-content bg-gradient-fashion">
    <section>
      <div class="page-header min-vh-100">
        <div class="container-fluid">
          <div class="row">
            <!-- Login Form Column -->
            <div class="col-lg-6 d-flex align-items-center justify-content-center">
              <div class="card card-plain bg-white shadow-lg w-100" style="max-width: 450px;">
                <div class="card-header pb-0 text-center bg-transparent">
                  <img src="/assets/Logo.png" alt="Fashion Logo" class="mb-3" style="max-height: 80px;">
                </div>
                <div class="card-body">
                  <form role="form" @submit.prevent="handleLogin()">
                    <div class="mb-3">
                      <argon-input
                        v-model="user.email"
                        type="email"
                        class="mb-0"
                        placeholder="Email"
                        name="email"
                        size="lg"
                        :value="user.email" />
                      <validation-error :errors="apiValidationErrors.email" />
                    </div>
                    <div class="mb-3">
                      <argon-input
                        v-model="user.password"
                        type="password"
                        placeholder="Contraseña"
                        name="password"
                        size="lg"
                        :value="user.password" />
                    </div>
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <argon-switch id="rememberMe">Recuérdame</argon-switch>
                    </div>
                    <div class="text-center">
                      <argon-button
                        type="submit"
                        class="mt-4 btn-fashion"
                        color="primary"
                        fullWidth
                        size="lg"
                      >Iniciar Sesión</argon-button>
                    </div>
                    <div class="text-center p-3">
                      <router-link
                        :to="{ name: 'Forgot Password' }"
                        class="text-fashion-secondary font-weight-bold"
                      >¿Olvidaste tu contraseña?</router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- Carousel Column -->
            <div class="col-12 col-md-6 d-none d-lg-block">
              <div class="carousel-container">
                <transition-group name="fade" tag="div" class="carousel">
                  <div v-for="(image, index) in carouselImages" :key="index" v-show="currentImage === index" class="carousel-image">
                    <img :src="image.src" :alt="image.alt"  style="height: 100%; width: 100%; object-fit: contain; object-position: center;">
                  </div>
                </transition-group>
                <div class="carousel-indicators" hidden>
                  <button v-for="(image, index) in carouselImages" :key="index" 
                          @click="currentImage = index"
                          :class="{ active: currentImage === index }"></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import formMixin from "../../mixins/form-mixin.js"
import ValidationError from "../../components/ValidationError.vue";
import showSwal from "../../mixins/showSwal.js";
import Swal from 'sweetalert2';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Login",
  components: {
    ArgonInput,
    ArgonSwitch,
    ArgonButton,
    ValidationError
  },
  mixins: [formMixin, showSwal],
  data() {
    return {
      user: {
        email: '',
        password: ''
      },
      currentImage: 0,
      carouselImages: [
        { src: '/assets/fashion-image-1.png', alt: 'Moda Elegante' },
        { src: '/assets/fashion-image-2.png', alt: 'Estilo Urbano' },
        { src: '/assets/fashion-image-3.png', alt: 'Accesorios de Moda' },
      ]
    }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
  mounted() {
    setInterval(() => {
      this.currentImage = (this.currentImage + 1) % this.carouselImages.length;
    }, 5000);
  },
  methods: {
    async handleLogin() {
      try {
        this.resetApiValidation();
        await this.$store.dispatch("auth/login", this.user);
        window.location.href = this.$router.resolve({ name: "Dashboard" }).href;

      }
      catch(error) {
        await Swal.fire({
          icon: 'error',
          title: 'Error de Estilo',
          text: 'Credenciales no combinan. Intenta de nuevo.',
        });
        this.setApiValidation(error.response.data.errors);
      }
    },
  }
};
</script>

<style scoped>
.bg-gradient-fashion {
  background: linear-gradient(135deg, #2C3A59 0%, #16243F 100%);
}

.card-plain {
  border-radius: 20px;
  overflow: hidden;
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.8);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.text-fashion-primary {
  color: #ff69b4 !important;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}

.text-fashion-secondary {
  color: #4a0e4e !important;
}

.btn-fashion {
  background: linear-gradient(45deg, #CC9900, #ffcc00) !important;
  border: none !important;
  color: #ffffff !important;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 105, 180, 0.3);
}

.btn-fashion:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 105, 180, 0.4);
}

.argon-input input {
  border: 2px solid #d9e4f5;
  border-radius: 10px;
  transition: all 0.3s ease;
  background-color: rgba(255, 255, 255, 0.9);
}

.argon-input input:focus {
  border-color: #ff69b4;
  box-shadow: 0 0 0 0.2rem rgba(255, 105, 180, 0.25);
}

.card-header {
  border-bottom: none;
  padding-bottom: 20px;
}

/* Carousel Styles */
.carousel-container {
  position: relative;
  height: 100%;
  overflow: hidden;
  align-items: center;
}

.carousel {
  height: 100%;
  position: relative;
  align-items: center;
}

.carousel-image {
  position: absolute;
  width: 100%;
  height: 'auto';
  object-fit: contain;
  align-items: center;
}

.carousel-image img {
  max-width:500px;
  max-height: 'auto';
  object-fit: contain;
}

.carousel-indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
}

.carousel-indicators button {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: none;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
}

.carousel-indicators button.active {
  background-color: #ffffff;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

@media (max-width: 991.98px) {
  .card-plain {
    margin: 20px;
  }
}
</style>

